// 百步梯中心（saas平台）接口

export default {
  register:'/Accounts',//注册 post

  confirmemail:'/Accounts/confirmemail',   //post  发送激活邮件

  PhoneNumber:'/Accounts/PhoneNumber',   //post  设置手机号并发送验证码

  ComfirmPhoneNumber:'/Accounts/ComfirmPhoneNumber',   //post  根据验证码激活手机号

  ForgotPassword:'/Accounts/ForgotPassword',   //post  忘记密码

  ComfirmPhoneNumberComplex:'/Accounts/ComfirmPhoneNumberComplex',   //post  根据验证码激活手机号(带公司信息)

  UnbindPhoneNumberCode:'/Accounts/UnbindPhoneNumberCode',   //post  发送解绑手机号验证码

  UnbindPhoneNumber:'/Accounts/UnbindPhoneNumber',   //put  解绑手机号

  profile:'/Accounts/profile',   //get  获取用户基本资料

  ChangePassword:'/Accounts/ChangePassword',   //post  修改密码

  tenantName:'/Accounts/tenantName',   //put  修改

  linkPhone:'/Accounts/LinkPhone',   //put  修改联系电话

  qq:'/Accounts/Qq',   //put  修改qq
  
  weiXin:'/Accounts/WeiXin',   //put  修改微信
  
  weiXinQrCode:'/Accounts/WeiXinQrCode',   //put  微信二维码

  contactAddress:'/Accounts/contactAddress',   //put  修改联系地址

  fullName:'/Accounts/fullName',   //put  修改姓名

  Job:'/Accounts/Job',   //put  修改职务

  userGroups:'/userGroups',   // get查询分组列表 //post  新增分组  //delete  删除分组  //put  修改员工分组名称

  users:'/users',   //get  查询用户列表  用户有关api 都是用这个  //注册子账号 post

  Tenants: '/Tenants', //get 获取 客户管理管理列表

  ImportedTenants: '/Tenants/ImportedTenants', // get 获取导入的租户列表

  TenantOwner: '/Tenants/TenantOwner', // post 重设租户邮箱

  OfflineTenantActivationEmail: '/Tenants/OfflineTenantActivationEmail', //post 重发导入用户的激活邮件

  test:'/Accounts/test',   //get

  test1:'/Accounts/test1',   //get

  menuitemsStart:'/serviceModules/',   //get  根据服务模块名称获取，改服务模块下的所有菜单————前半截

  menuitemsEnd:'/menuitems',//get  根据服务模块名称获取，改服务模块下的所有菜单————后半截

  MenuItems:'/MenuItems',//get  根据服务模块名称获取，改服务模块下的所有菜单

  ServiceModules:'/ServiceModules',   //get  得到所有的服务模块

  UploadFiles: '/Admin/UploadFiles',  //  上传头像

  photo: '/Accounts/photo',  // 保存头像url  到后台

  permissions:'/Accounts/permissions',   //获取用户权限

  getAllbusinessManagers: '/businessManagers', // 获取业务经理

  businessManagersByGroupIds:'/businessManagersByGroupIds', //获取销售经理客服经理

  changeVatManager: '/Tenants/BusinessManager', //更新VAT业务经理

  changeContactInfo: '/tenants/serviceModuleContact', //更新VAT业务经理

  //产品管理
  productList:'/Product/page',//分页

  // 导出订单
  buyManageExport:'/PurchaseOrder/export',

  // 

}




// WEBPACK FOOTER //
// ./src/public/saasApi.js